import React, {memo} from 'react';
import {Chip} from '@mui/material';

export const TitleChip = ({sx, ...props}) => {
  return (
    <Chip
      {...props}
      sx={[{marginLeft: 1}, ...(Array.isArray(sx) ? sx : [sx])]}
    />
  );
};

TitleChip.propTypes = Chip.propTypes;

TitleChip.defaultProps = {
  shape: 'square',
  size: 'small',
  color: 'secondary',
};

export default memo(TitleChip);
